import $ from 'domtastic'

import { autoScrollTo, DOMPosition } from '@utils/utils'
import Woosh from '@utils/Woosh'

import B, { getUtils, getRefs } from '@comps/_common/_Base'

import LangSwitch from '@blocks/ui/LangSwitch'
import Slider from '@blocks/Slider'
import YouTubeIframe from '@blocks/YouTubeIframe'
import Overlay from '@blocks/Overlay'
import StoryVideo from '@blocks/StoryVideo'
import LatestVideos from '@blocks/LatestVideos'
import GuideBackground from '@blocks/GuideBackground'
import StepNav from '@blocks/StepNav'
import Wall from '@blocks/Wall'
import FeaturedQuestions from '@blocks/FeaturedQuestions'
import TileSelector from '@blocks/TileSelector'
import Accordion from '@blocks/Accordion'
import Filters from '@blocks/Filters'
import Filter from '@blocks/Filter'

const compsMap = {
    LangSwitch,
    YouTubeIframe,
    Slider,
    Overlay,
    StoryVideo,
    LatestVideos,
    GuideBackground,
    StepNav,
    FeaturedQuestions,
    Wall,
    TileSelector,
    Accordion,
    Filters,
    Filter,
}




/* VIEW: BASEVIEW
---------------------------------------------------------------------------------------------------- */

export default class BaseView extends B {

    constructor(props = {}) {
        super(props.namespace)

        this.props     = props
        this.namespace = (props && props.namespace) ? props.namespace : 'base'
        this.view      = document.body.getAttribute('data-v')
        this.comps     = {}

        this.$utils = getUtils()
        this.$refs  = getRefs(document.body, this.view.charAt(0).toUpperCase() + this.view.slice(1))

        this.parser = new DOMParser()

        this.baseResizeHandler = () => { this.onResize() }
        this.basePageWillChangeHandler  = (e) => { this.onPageWillChange(e.detail) }


        // @TODO: Remove if using Barba.
        // this.beforeEnter({
        //     next: {
        //         container: document.querySelector('.view'),
        //         html: document.documentElement.innerHTML,
        //     },
        // })
    }


    bindBaseEvents() {
        this.on()
    }


    destroy() {
        if (!this.view) return

        this.initialized = false
        this.off()
    }




    /* Hooks
    --------------------------------------------------------- */

    beforeLeave() {
        //
    }


    afterLeave() {
        this.destroy()

        this.comps = {}
    }


    beforeEnter({ next }) {
        const html = this.parser.parseFromString(next.html, 'text/html')

        this.$ctn = $(next.container)
        this.view = html.body.getAttribute('data-v')
        this.woosh = new Woosh(this.$ctn)

        this.events = [
            [document, 'layoutChange', this.baseResizeHandler],
        ]

        this.initYTiFrame()
        this.splitText()
        this.getAnchors()

        this.bindBaseEvents()
        setTimeout(() => { this.init() }, 0)
    }


    // afterEnter() {
        // this.initComps('data-after-component', true)
    // }




    /* Init
    --------------------------------------------------------- */

    init() {
        this.initialized = true

        this.initComps('data-component', true)
    }


    initComps(sel = 'data-component', initWoosh) {
        if (initWoosh) {
            this.woosh.init()
        }


        $(`[${sel}]`).each((el, i) => {
            const $el = $(el)

            const compName  = $el.attr(sel).replace(/-|\s/g, '')
            const compsList = compName.split(',')

            $el.removeAttr(sel)

            compsList.forEach((c) => {
                if (compsMap[c]) {
                    if (!this.comps[c]) {
                        this.comps[c] = []
                    }

                    this.comps[c].push(new compsMap[c]($el, this.namespace, this.view, this, i))
                } else {
                    console.warn(`Component [${c}] not registered in BaseView.`)
                }
            })
        })
    }


    initYTiFrame() {
        this.ytAPI = new YouTubeIframe(this.$ctn, this.namespace)
    }




    /* Handlers
    --------------------------------------------------------- */

    onPageWillChange() {
        this.comps = {}
    }


    onResize() {
        this.splitText()
    }


    /* eslint-disable class-methods-use-this */
    onAnchorClick(e) {
        e.preventDefault()

        const $target = e.target
        const $hrefTarget = $target.getAttribute('href') || $target.closest('[href]').getAttribute('href')
        const offset = parseInt($target.dataset?.offset || 0, 10)

        scrollToID($hrefTarget, APP.Layout.isDesktop ? offset : offset / 2)
    }
    /* eslint-enable class-methods-use-this */




    /* Actions
    --------------------------------------------------------- */

    splitText() {
        this.woosh.splitText()
    }


    getAnchors() {
        const $anchors = this.$ctn.find('.js-anchorLink')

        $anchors.forEach(($a) => {
            $a.addEventListener("click", (e) => this.onAnchorClick(e));
        });
    }

}




/* CONSTANTS AND HELPERS
---------------------------------------------------------------------------------------------------- */

const scrollToID = (id, offset) => {
    const $target = document.querySelector(id)

    if ($target) {
        const { y } = DOMPosition($target)
        autoScrollTo(y - offset)
    }
}



